module.exports = __webpack_public_path__ + "static/img/IE.dea50c27.svg";